import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { HomeUseParams } from './service';

export enum HomeUseActions {
  Failure = '[Catalogs HomeUse] Failure',
  Request = '[Catalogs HomeUse] Request',
  Success = '[Catalogs HomeUse] Success',
}

export const HomeUseFailure = createAction(HomeUseActions.Failure, props<{ error: HttpErrorResponse }>());

export const HomeUseRequest = createAction(HomeUseActions.Request, props<{ parameters: HomeUseParams }>());

export const HomeUseSuccess = createAction(HomeUseActions.Success, props<{ data: ParameterResult }>());
